/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetSessionQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSessionQuery = {
  readonly __typename?: 'Query';
  readonly session: {
    readonly __typename?: 'Session';
    readonly csrf: string;
    readonly isLoggedIn: boolean;
  };
};

export const getSessionQueryMock: ExecutionResult<GetSessionQuery> = {
  data: { session: { csrf: 'Hello World', isLoggedIn: true } },
};

export const GetSessionDocument = gql`
  query getSession {
    session {
      csrf
      isLoggedIn
    }
  }
`;

export function useGetSessionQuery(
  options?: Omit<Urql.UseQueryArgs<GetSessionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSessionQuery, GetSessionQueryVariables>({
    query: GetSessionDocument,
    ...options,
  });
}
